document.addEventListener("teeinblue-event-component-injected", function () {
  var selectBoxes = document.querySelectorAll(".tee-field__select");

  selectBoxes.forEach(function (selectBox) {
    var options = selectBox.options;

    for (var i = 0; i < options.length; i++) {
      var text = options[i].textContent;
      if (text.includes("&euro;")) {
        options[i].textContent = text.replace(/&euro;/g, "€");
      }
    }
  });

  // Watch variant change
  const variantInputContainer = document.querySelector(
    '[data-update-block="variant-id-main"]'
  );

  if (variantInputContainer) {
    const observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          document.dispatchEvent(
            new CustomEvent("shopify-event-variant-changed"),
          );
        }
      }
    });

    observer.observe(variantInputContainer, {
      attributes: false,
      subtree: false,
      childList: true,
    });
  }

  (function() {
    function isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    function checkShouldBlock() {
      if (isMobile()) return false;
      var globalBlock = window.teeinblue && window.teeinblue.shouldBlockInspect;
      var campaignBlock = window.teeinblueCampaign && window.teeinblueCampaign.config && window.teeinblueCampaign.config.should_block_inspect;
      var shopBlock = window.teeinblueShopConfig && window.teeinblueShopConfig.should_block_inspect;
      return !!(globalBlock || campaignBlock || shopBlock);
    }

    document.addEventListener('contextmenu', function(e) {
      if (checkShouldBlock()) {
        e.preventDefault();
      }
    }, { capture: true });

    document.addEventListener('keydown', function(e) {

      if (!checkShouldBlock()) return;

      // F12
      if (e.key === 'F12' || e.keyCode === 123) {
        e.preventDefault();
      }

      // Ctrl + Shift + (I, C, J) - Windows
      // Cmd + Option + (I, C, J) - Mac
      var isInspectKeys = (e.key && ['i', 'c', 'j'].includes(e.key.toLowerCase())) || [73, 67, 74].includes(e.keyCode);
      if (isInspectKeys) {
        if ((e.ctrlKey && e.shiftKey) || (e.metaKey && e.altKey)) {
          e.preventDefault();
        }
      }

      // Ctrl + U (Win)
      // Cmd + Option + U (Mac) - View Source
      var isViewSourceKey = (e.key && e.key.toLowerCase() === 'u') || e.keyCode === 85;
      if (isViewSourceKey) {
        if (e.ctrlKey || (e.metaKey && e.altKey)) {
          e.preventDefault();
        }
      }

    }, { capture: true });
  })();
});
